import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-subscription-banner',
  templateUrl: './subscription-banner.component.html',
  styleUrl: './subscription-banner.component.css'
})
export class SubscriptionBannerComponent {

  @Input() daysRemaining: number = 0;

  @Output() renew = new EventEmitter<void>();

  @Output() close = new EventEmitter<void>();

  onRenew(): void {
    this.renew.emit();
  }

  onClose(): void {
    this.close.emit();
  }
}